import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiUserPackagesGet } from '@/entities/user-packages/modules/api/userPackages';

// Pagination is page-based (10 per page is the owner-spec default).
export const useUserPackages = (page: number = 1, pageSize: number = 10) =>
  useFetch({
    api: () => apiUserPackagesGet(page, pageSize),
    keywords: queryKeys.userPackages.list(page),
    staleTime: 60_000,
  });
